import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const CreacionPTApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTiposProducto = async (params) => {
        const finalParams = {
            es_producto_terminado: true,
            ...params,
        };
        return api
            .get("tipo_materia_prima", finalParams)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getPadresProductoTerminado = async (params) => {
        return api
            .get("padres_producto_terminado", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const crearPT = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("materia_prima", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarPT = async (id, data) => {
        try {
            setCargando(true);
            const response = await api.put(`materia_prima/${id}`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getDetalleMateriaPrima = async (id) => {
        try {
            setCargando(true);

            const response = await api.get(`materia_prima/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTiposProducto,
        getPadresProductoTerminado,
        crearPT,
        actualizarPT,
        getDetalleMateriaPrima,

        cargando,
    };
};
